import { useQuery } from '@tanstack/react-query';

import { TCommentType } from '@entities/comment/model/types';
import { commentsApi } from '@widgets/Comments/api';

export const useGetCommentList = ({
    positionId,
    commentType,
}: {
    positionId: string;
    commentType: TCommentType;
}) =>
    useQuery({
        ...commentsApi.getCommentListQueryOptions({ positionGuid: positionId, commentType }),
        refetchInterval: 3000,
    });
